import { Col } from "react-bootstrap";
import InputTextField from "../inputTextField/InputTextField";
import InputPasswordField from "../inputPasswordField/InputPasswordField";

const LeadsOnlineForm = ({ disabled = false }) => {
  return (
    <>
      <Col md={6} className="mb-3">
        <InputTextField
          name="leadsOnlineStoreId"
          placeHolder="Enter Leads Online Store Id"
          label="Leads Online Store Id"
          disabled={disabled}
        />
      </Col>
      <Col md={6} className="mb-3">
        <InputTextField
          name="leadsOnlineUsername"
          placeHolder="Enter Leads Online Username"
          label="Leads Online Username"
          disabled={disabled}
        />
      </Col>
      <Col md={6} className="mb-3">
        <InputPasswordField
          name="leadsOnlinePassword"
          label="Leads Online Password"
          placeHolder="Enter Leads Online Password"
          className="w-100"
          disabled={disabled}
        />
      </Col>
    </>
  );
};

export default LeadsOnlineForm;
